import { Injectable, inject } from '@angular/core';
import { Auth, GoogleAuthProvider, signInWithRedirect, user } from '@angular/fire/auth';
import { Database, objectVal, ref } from '@angular/fire/database';
import { Observable, map, of, switchMap } from 'rxjs';
import { EMPTY } from 'rxjs/internal/observable/empty';

@Injectable({
  providedIn: 'root'
})
export class AuthzService {
  private readonly db = inject(Database);
  private readonly auth = inject(Auth);

  isAuthorized(eventKey: string): Observable<boolean> {
    return user(this.auth).pipe(
      switchMap(user => {
        if (user) {
          return objectVal(ref(this.db, `events/${eventKey}/authz/${user.uid}`)).pipe(switchMap(async hasAuth => {
            if (hasAuth) return true;
    
            const tokenResult = await user.getIdTokenResult();
            if (tokenResult?.claims['superAdmin']) return true;
    
            return false;
          }));
        }

        signInWithRedirect(this.auth, new GoogleAuthProvider());
        return EMPTY;
      }),
    );
  }

  isSuperAdmin(): Observable<boolean> {
    return user(this.auth).pipe(
      switchMap(user => user ? user.getIdTokenResult() : of(undefined)),
      map(tokenResult => !!tokenResult?.claims['superAdmin']));
  }
}
